export const HOME_INSTEAD_FIND_CARE_URL = 'https://homeinstead.co.uk/find-home-care'

export const redirectToHomeInsteadFindCare = (postcode = null) => {
	let url = HOME_INSTEAD_FIND_CARE_URL;
	if (postcode) {
		url += `?searchTerm=${postcode}`;
	}
  window.location.href = url;
};